import 'core-js/stable';

import { App } from './app/components/App.tsx';
import * as Configuration from './utils/Configuration.ts';
import * as Sentry from './utils/Sentry.ts';
import * as fluxInstance from './fluxInstance.ts';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { initUpdater } from 'dg-web-shared/common/utils/UpdateUtils.ts';

// install error tracking
const dsn = Configuration.getSentryProjectDSN();
if (dsn) {
    Sentry.init(dsn);
}

type WebkitWindow = {
    webkitRequestAnimationFrame: (callback: FrameRequestCallback) => void;
} & Window &
    typeof globalThis;

window.requestAnimationFrame =
    window.requestAnimationFrame ||
    (<WebkitWindow>window).webkitRequestAnimationFrame ||
    function (f: () => void): void {
        window.setTimeout(f, 1000 / 30);
    };

initUpdater();

const container = document.getElementById('app-container');
const root = createRoot(container!);
root.render(
    React.createElement(App, {
        allState: fluxInstance.flux,
    }),
);
